import { EGender } from 'affiny-core/modules/account/types';
import differenceInYears from 'date-fns/differenceInYears';
import { ICompatibilityReport, IMember } from '../../../members/types';
import {
  IApiCompatibilityReportLight,
  IApiMemberProfileAttributes,
} from './member.types';

export const coreMemberSerializer = (
  data: IApiMemberProfileAttributes
): IMember => ({
  id: data.id,
  attributes: {
    nickname: data.attributes.nickname,
    birthdate: data.attributes.birthdate,
    kvk: data.attributes.kvk,
    gender: data.attributes.kvk.charAt(0) as EGender,
    wantedGender: data.attributes.kvk.charAt(1) as EGender,
    geo: {
      city: data.attributes.geo.city,
      region: {
        id: data.attributes.geo.region?.id,
        name: data.attributes.geo.region?.name,
      },
      country: {
        isocode: data.attributes.geo.country.isocode,
        name: data.attributes.geo.country.name,
      },
    },
    isBlacklisted: data.attributes.isBlacklisted,
    privacy: {
      privatePicture: data.attributes.privacy.privatePicture,
    },
    age: differenceInYears(new Date(), data.attributes.birthdate),
  },
});

export const compatiblityReportSerializer = (
  apiCompatibilityReport: IApiCompatibilityReportLight,
  accountId: string
): ICompatibilityReport => ({
  ...apiCompatibilityReport,
  accountId,
});
